import React, { Component } from 'react';
import { connect } from 'react-redux';
import {LOG_LEVELS} from "../../utils/logger";
import Logger from "../../utils/logger";
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import AvaJsonTreeview from "../documentViewers/json/AvaJsonTreeview";
import NoData from '../page/NoData';

const log = new Logger('VATCODE_SIMULATOR_DETAILS', LOG_LEVELS.DEBUG);

export class VATCodeDetails extends Component {

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
  }

  render() {
    log.debug('render(): ', this.props);

    if (!this.props.vatCodeSimulator.VATCode)  {
      return (
        <div>
          <NoData
            noDataText="vatCodeSimulator_NoData"
          />
        </div>)
    }

    return (
      <div>
        <AvaJsonTreeview
           src={this.props.vatCodeSimulator.ux}
           collapsed={false}
           name={this.props.vatCodeSimulator.title}
        />
      </div>
    );
  }
}



function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        vatCodeSimulator : (state.vatCodeSimulator && state.vatCodeSimulator.vatCodeDetails) || []
    };
}


export default connect(mapStateToProps)(VATCodeDetails);
